export default __webpack_public_path__ + "static/media/quoteicon.9bca0987.svg";